import styled from 'styled-components'

const Content = styled.div`
  line-height: 1.6em;
`

export { Content }
